import { render, staticRenderFns } from "./MobileAppCarouselItem.vue?vue&type=template&id=22ee8084&scoped=true"
import script from "./MobileAppCarouselItem.vue?vue&type=script&lang=ts"
export * from "./MobileAppCarouselItem.vue?vue&type=script&lang=ts"
import style0 from "./MobileAppCarouselItem.vue?vue&type=style&index=0&id=22ee8084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ee8084",
  null
  
)

export default component.exports